import { render } from "./DashboardAddTemplateData.vue?vue&type=template&id=366b9e71"
import script from "./DashboardAddTemplateData.vue?vue&type=script&lang=js"
export * from "./DashboardAddTemplateData.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__